import { Box, Button, Typography, Container } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NoticeBox from "./NoticeBox";

const bulletPoints = [
    "Attachments will be deleted a few days after the email status is marked as 'Completed'",
];

const PostEmailView = ({}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { email, emailId } = location.state || {
        email: { content: "", subject: "", attachment_urls: [] },
        emailId: "",
    };

    return (
        <Box
            sx={{
                width: "95%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "100%",
                padding: "1rem",
            }}
        >
            <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/email-queue")}
                sx={{ mb: 2 }}
            >
                Back
            </Button>
            <Typography
                sx={{
                    fontWeight: "600",
                    fontSize: "1.1rem",
                    marginLeft: "2.5rem",
                }}
            >
                To : {emailId}
            </Typography>

            <Container maxWidth="md" sx={{ my: 4 }}>
                {/* <Paper elevation={3} sx={{ p: 4 }}> */}
                <Typography sx={{ fontSize: "1.1rem" }} gutterBottom>
                    <span style={{ fontWeight: "600" }}>Subject :</span>
                    <span>{email.subject}</span>
                </Typography>

                {/* Render HTML safely */}
                <div
                    className="quill-content"
                    dangerouslySetInnerHTML={{ __html: email.content }}
                />
                {/* </Paper> */}
                {email.attachment_urls?.length > 0 && (
                    <Box
                        sx={{
                            marginTop: "1rem",
                            padding: "0.75rem",
                            border: 1,
                            borderColor: "#b3b2b1",
                        }}
                    >
                        <Typography
                            sx={{ fontSize: "1rem", fontWeight: "700" }}
                        >
                            Attachments:
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                height: "auto",
                                padding: "1rem",
                                justifyContent: "flex-start",
                            }}
                        >
                            <ol>
                                {email.attachment_urls.map((url) => {
                                    return (
                                        <li>
                                            <a
                                                href={`${url}`}
                                                download={url}
                                                target="_blank"
                                            >
                                                Download Docs
                                            </a>
                                        </li>
                                    );
                                })}
                            </ol>
                        </Box>
                    </Box>
                )}
            </Container>

            <Box
                sx={{
                    padding: "1rem",
                    border: 1,
                    borderColor: "#a19f9f",
                    borderRadius: 1,
                }}
            >
                <NoticeBox bulletPoints={bulletPoints} />
            </Box>

            
        </Box>
    );
};

export default PostEmailView;
